import type {
  AvailableLanguages,
  LanguageInfo,
  LanguageNamePerCode,
  UseAvailableLanguages,
} from 'src/types/reportConfig';
import { useSection } from 'src/components/app/context/SectionContext';
import { useReportConfigAllocationAvailableLanguagesQuery } from 'src/components/reportConfig/hooks/useReportConfigAllocationAvailableLanguagesQuery';

export const useAvailableLanguages = (): UseAvailableLanguages => {
  const { moduleId } = useSection();
  const {
    data: availableLanguagesData,
    loading,
    fetched,
  } = useReportConfigAllocationAvailableLanguagesQuery(moduleId);
  const data: AvailableLanguages =
    availableLanguagesData?.availableLanguages || [];
  const shoppingCartLanguages: LanguageInfo[] = data.map(
    ({ code, abbreviation }) => ({ code, abbreviation }),
  );
  const languageNamesPerCode: LanguageNamePerCode = Object.fromEntries(
    data.map((languageDetails) => [languageDetails.code, languageDetails.name]),
  );
  return {
    data,
    shoppingCartLanguages,
    languageNamesPerCode,
    loading,
    fetched,
  };
};
